var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"body-wrap"}},[_c('LayoutHeader',{attrs:{"title":"은평 생활","color":"bg-blue"}},[_c('ul',{staticClass:"category_list",attrs:{"slot":"navigator"},slot:"navigator"},[_c('li',[_vm._v("홈")]),_c('li',[_vm._v("은평 생활")]),_c('li',[_vm._v("생활 지도")])])]),_c('Lifemap')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }